import { useUserStore } from '../../store/useUserStore';
import styles from './AdBanner.module.css';
import { IS_FREE_LAUNCH_PHASE } from '../../config';

// 지도나 리스트 하단에 들어갈 배너 광고 스켈레톤
export function AdBanner() {
  const isPremium = useUserStore((state) => state.isPremium);

  // 프리미엄 사용자이거나 무료 배포 모드일 경우 배너 광고를 보지 않음
  if (isPremium || IS_FREE_LAUNCH_PHASE) return null;

  return (
    <div className={styles.adBanner}>
      <span>[광고] 구글 애드센스 / AdMob 배너 영역</span>
    </div>
  );
}
